module.exports = __webpack_public_path__ + "img/Scanvaegt0.af323385.png";